import APIS from '../apis';

/**
 * 微信分享配置的方法
 * @param shareConfig
 */
export function doWxShareConfig(shareConfig) {
    wxSDKLoadTask.then(function() {
        // console.info('配置' + this.$route.meta.title + '微信分享');
        wx.ready(function () {
            // wx.hideMenuItems({
            //     menuList: [
            //         'menuItem:share:qq',
            //         'menuItem:share:weiboApp',
            //         'menuItem:share:QZone',
            //         'menu:share:timeline',
            //         // "menuItem:openWithSafari"
            //     ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
            // });
            wx.onMenuShareTimeline({
                title: shareConfig.title, // 分享标题
                link: shareConfig.link, // 分享链接
                imgUrl: shareConfig.imgUrl, // 分享图标
                success: shareConfig.successTimeline ? shareConfig.successTimeline : shareConfig.success,
                cancel: shareConfig.cancel
            })
            wx.onMenuShareAppMessage({
                title: shareConfig.title, // 分享标题
                desc: shareConfig.desc, // 分享描述
                link: shareConfig.link, // 分享链接
                imgUrl: shareConfig.imgUrl, // 分享图标
                type: 'link', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: shareConfig.successAppMessage ? shareConfig.successAppMessage : shareConfig.success,
                cancel: shareConfig.cancel
            })
        });
    });
};


/**
 * 微信JSSDK 配置
 * @param data
 * @param errorCallback
 */
export function wxConfig(data) {
    return wxSDKLoadTask.then(function() {
        return new Promise(function(resolve, reject){
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: data.appId, // 必填，公众号的唯一标识
                timestamp: data.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                signature: data.signature, // 必填，签名，见附录1
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'hideMenuItems',
                    'showMenuItems',
                    'chooseWXPay',
                    'chooseImage',
                    'getLocalImgData',
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            // 这里resolve的话，error的reject就没意义了 --@by cyc
            // resolve();
            wx.ready(resolve);

            wx.error(function (res) {
                // alert(res.errMsg);
                // window.monitor.stat({
                //     level: 'warn',
                //     error: 'API-data',
                //     url: APIS.wechatData,
                //     message: res.errMsg
                // });
                console.log(res)
                reject();
            })
        })
    })
}

export default  {
    wxConfig,
    doWxShareConfig
}



// WEBPACK FOOTER //
// ./src/lib/wxActions.js